// extracted by mini-css-extract-plugin
export default {"desc":"TalentPartner_desc__iVz8z","cards":"TalentPartner_cards__yYbSX"};